import React from 'react';
import Wholesalepage from './Wholesalepage';

const Wholesale = () => {
	console.log('wholesale');
	return (
		<div>
			<Wholesalepage />
		</div>
	);
};

export default Wholesale;
